import { selectUserData, setMe } from "../../app/userSlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { login, logout } from "../../app/api";
import DummyLoginButton from "./DummyLoginButton";
import TelegramLoginButton from "./TelegramLoginButton";

const AccountButton = () => {
  const userData = useAppSelector(selectUserData);
  const dispatch = useAppDispatch();

  const onAuth = (authData: any) => {
    login(authData).then((res) => dispatch(setMe(res)));
  };

  if (userData.isLoggedIn) {
    return (
      <div style={{ display: "flex", alignItems: "baseline" }}>
        <h3 style={{ margin: 0, marginRight: 10 }}>
          {userData.data?.username}
        </h3>
        <a onClick={() => logout().then((res) => dispatch(setMe(res)))}>
          выйти
        </a>
      </div>
    );
  }

  return process.env.NODE_ENV === "development" ? (
    <DummyLoginButton onAuth={onAuth} />
  ) : (
    <TelegramLoginButton onAuth={onAuth} />
  );
};

export default AccountButton;
